module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/map.js
// module id = 2131
// module chunks = 102